"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Spinner: function() {
        return _Spinner.Spinner;
    },
    spinnerClassNames: function() {
        return _Spinner.spinnerClassNames;
    },
    renderSpinner_unstable: function() {
        return _Spinner.renderSpinner_unstable;
    },
    useSpinner_unstable: function() {
        return _Spinner.useSpinner_unstable;
    },
    useSpinnerStyles_unstable: function() {
        return _Spinner.useSpinnerStyles_unstable;
    },
    SpinnerContextProvider: function() {
        return _index.SpinnerContextProvider;
    },
    useSpinnerContext: function() {
        return _index.useSpinnerContext;
    }
});
const _Spinner = require("./Spinner");
const _index = require("./contexts/index");
